import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CardWrapper = styled.div`
  width: 100%;
  flex-direction: column;
  position: relative;
  background: ${COLORS.BgMain};
  ${FONTS.XXS};
`;
